/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for facetTypeEnabled. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="facetTypeEnabled"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="automatic"/&gt; &lt;enumeration value="true"/&gt; &lt;enumeration value="false"/&gt; &lt;enumeration value="custom"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class FacetTypeEnabled extends Enum{

	enumValue = null;

	/**
	 * automatic is resolved to true or false. Rule: true if the usage of the query item/calculation is attribute, and the data type supports precise value comparison (e.g. false for float/double because they are approximate number) 								
	 */
	static  AUTOMATIC = FacetTypeEnabled.newLiteral("automatic");

	static  TRUE = FacetTypeEnabled.newLiteral("true");

	static  FALSE = FacetTypeEnabled.newLiteral("false");

	static  CUSTOM = FacetTypeEnabled.newLiteral("custom");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < FacetTypeEnabled.values().length); ++i) {
			if (FacetTypeEnabled.values()[i].enumValue == v) {
				return FacetTypeEnabled.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("FacetTypeEnabled" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/FacetTypeEnabled.js